import {useContext, useEffect, useState} from 'react'
import {Button, Form, Row} from 'react-bootstrap'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import {createCustomExternal, getExternalById, getExternals} from '../../../../services/external'
import {SheetEditContext} from '../SheetContexts'
import AssigmentListGroup from './AssigmentListGroup'

const AssignmentEntityModalForm = () => {
  const {closeEntityModal, fieldData, setFieldData, sheetData, setData, sectionData} =
    useContext(SheetEditContext)
  const [idServices, setIdServices] = useState<string[]>([])
  const [dataInput, setDataInput] = useState<Record<string, any>>({})
  const [services, setServices] = useState<{label: string; value: string}[]>([])
  const [idServiceSelected, setIdServiceSelected] = useState('')
  const [activeRefetch, setActiveRefetch] = useState(false)

  useEffect(() => {
    refetchData()
  }, [])

  useEffect(() => {
    if (activeRefetch) {
      refetchData()
      setActiveRefetch(false)
    }
  }, [activeRefetch])

  useEffect(() => {
    console.log(idServices)
    if (idServices.length > 0) {
      idServices.forEach((id) => {
        getExternalId(id)
      })
    }
  }, [idServices])

  const refetchData = async () => {
    try {
      const response = await getExternals({typedata: 'NAME_SERVICES', includeCompany: true})
      if (response.success) {
        if (response?.data?.length === 0) {
          const response = await createCustomExternal()
          if (response.success) {
            const response = await getExternals({typedata: 'NAME_SERVICES', includeCompany: true})
            if (response.success) {
              const SeriviceRequerida = response.data.filter(
                // change with ID === 'ENTITY'
                (da: any) => da.idService === 'ENTITY'
              )
              setIdServices(SeriviceRequerida.map((item: any) => item._id))
              setServices(
                SeriviceRequerida.map((item: any) => ({
                  label: item.service,
                  value: item._id,
                }))
              )
              setIdServiceSelected(SeriviceRequerida?.[0]?._id ?? '')
            }
          }
        } else {
          const SeriviceRequerida = response.data.filter(
            // change with ID === 'ENTITY'
            (da: any) => da.idService === 'ENTITY'
          )
          setIdServices(SeriviceRequerida.map((item: any) => item._id))
          setServices(
            SeriviceRequerida.map((item: any) => ({
              label: item.service,
              value: item._id,
            }))
          )
          setIdServiceSelected(SeriviceRequerida?.[0]?._id ?? '')
        }
      } else {
        console.log(response.msg)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getExternalId = async (id: string) => {
    await getExternalById(id)
      .then((response) => {
        console.log('response')
        console.log(response)
        setDataInput((prev) => ({...prev, [id]: response?.data?.fields || []}))
      })
      .catch((error) => console.log(error))
  }

  const handleListChange = (name: string, checkboxes: Record<string, boolean>) => {
    const infoAssignTo = name
      ? {
          isReadable: checkboxes.read ?? false,
          isWritable: checkboxes.write ?? false,
          assignTo: name,
          idService: idServiceSelected,
        }
      : undefined

    setFieldData({
      ...fieldData,
      // assignedTo: name, // comments this
      infoAssignTo,
    })
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()

    setData({
      ...sheetData,
      sections: (sheetData.sections || []).map((x) =>
        x.id === sectionData.id
          ? {
              ...sectionData,
              fields: (sectionData.fields || []).map((y) =>
                y.id === fieldData.id ? fieldData : y
              ),
            }
          : x
      ),
    })
    closeEntityModal()
  }

  return (
    <>
      <Form noValidate onSubmit={handleSubmit}>
        <Form.Group className='mb-3' controlId='formServicio'>
          <Form.Label>
            Servicio: {services.find((s) => s.value === idServiceSelected)?.label}{' '}
          </Form.Label>
          {/* <Select
            options={services}
            value={services.find((s) => s.value === idServiceSelected) ?? services[0]}
            onChange={(e) => setIdServiceSelected(e?.value ?? '')}
          /> */}
        </Form.Group>

        <Row className='mb-3'>
          <AssigmentListGroup
            serviceSelected={idServiceSelected}
            elementSelected={fieldData.infoAssignTo?.assignTo} // fieldData.infoAssignTo.assignTo
            onChange={(name: string, checkboxes: Record<string, boolean>) =>
              handleListChange(name, checkboxes)
            }
            dataInput={dataInput}
            setActiveRefetch={setActiveRefetch}
          />
        </Row>

        <Row>
          <div className='d-flex justify-content-end'>
            <Button
              variant='light'
              className='mx-3'
              type='reset'
              onClick={() => {
                closeEntityModal()
              }}
            >
              Cancelar
            </Button>
            <Button variant='primary' type='submit'>
              Guardar
            </Button>
          </div>
        </Row>
      </Form>
    </>
  )
}

export {AssignmentEntityModalForm}
